<template>
  <div class="home">
    <main>
      <!-- <banner /> -->
      <section>
        <a href="/wall-tower" title="Learn more about Contrology Wall Tower & High Mat">
          <img style="width:100%; max-width:996px; display:block; margin:0 auto" src="https://s3.amazonaws.com/s3.pilates.com/contrology/contrology_walltower-highmat_hp-banner@1x.jpg" srcset="https://s3.amazonaws.com/s3.pilates.com/contrology/contrology_walltower-highmat_hp-banner@2x.jpg 2x" alt="Contrology Wall Tower &amp; High Mat" />
        </a>
      </section>
      <h1 class="title">Looking forward sometimes means looking back</h1>
      <section id="anchor" class="youtube-wrapper">
        <a @click="showModal = true" href="#">
          <img
            src="@/assets/banner-contrology-home@1x.jpg"
            srcset="@/assets/banner-contrology-home@2x.jpg 2x"
            class="video"
            alt="In-use photo of woman working out on a Contrology Arm Chair"
          />
          <div class="btn-wrapper">
            <span>
              <span></span>
            </span>
          </div>
        </a>
      </section>
      <section class="product-grid">
        <a href="reformer" title="Learn more about Contrology Reformer">
          <figure class="product clr1">
            <figcaption>Reformer</figcaption>
            <img
              src="@/assets/btn-reformer@1x.png"
              srcset="@/assets/btn-reformer@2x.png 2x, @/assets/btn-reformer@3x.png 3x"
              alt="Photo of Reformer"
            >
          </figure>
        </a>
        <a href="cadillac" title="Learn more about Contrology Cadillac">
          <figure class="product clr2">
            <figcaption>Cadillac</figcaption>
            <img
              src="@/assets/btn-cadillac@1x.png"
              srcset="@/assets/btn-cadillac@2x.png 2x, @/assets/btn-cadillac@3x.png 3x"
              alt="Photo of Cadillac"
            >
          </figure>
        </a>
        <a href="folding-mat" title="Learn more about Contrology Folding Mat">
          <figure class="product clr5">
            <figcaption>Folding Mat</figcaption>
            <img
              src="@/assets/btn-foldingmat@1x.png"
              srcset="@/assets/btn-foldingmat@2x.png 2x, @/assets/btn-foldingmat@3x.png 3x"
              alt="Photo of Folding Mat"
            >
          </figure>
        </a>
        <a href="arm-chair" title="Learn more about Contrology Arm Chair">
          <figure class="product clr4">
            <figcaption>Arm Chair</figcaption>
            <img
              src="@/assets/btn-armchair@1x.png"
              srcset="@/assets/btn-armchair@2x.png 2x, @/assets/btn-armchair@3x.png 3x"
              alt="Photo of Arm Chair"
            >
          </figure>
        </a>
        <a href="ped-o-pul" title="Learn more about Contrology Ped-o-Pul">
          <figure class="product clr3">
            <figcaption>Ped-o-pul</figcaption>
            <img
              src="@/assets/btn-pedopul@1x.png"
              srcset="@/assets/btn-pedopul@2x.png 2x, @/assets/btn-pedopul@3x.png 3x"
              alt="Photo of Ped-o-pul"
            >
          </figure>
        </a>
        <!-- <a href="accessories/Springs" title="Learn more about Contrology Springs">
          <figure class="product clr6">
            <figcaption>Springs</figcaption>
            <img
              src="@/assets/btn-springs@1x.png"
              srcset="@/assets/btn-springs@2x.png 2x, @/assets/btn-springs@3x.png 3x"
              alt="Photo of Springs"
            >
          </figure>
        </a>
        <a href="accessories/" title="Learn more about Contrology Accessories">
          <figure class="product clr3">
            <figcaption>Accessories</figcaption>
            <img
              src="@/assets/btn-accessories@1x.png"
              srcset="@/assets/btn-accessories@2x.png 2x, @/assets/btn-accessories@3x.png 3x"
              alt="Photo of Accessories"
            >
          </figure>
        </a> -->
        <a href="/ladder-barrel" title="Learn more about Ladder Barrel">
          <figure class="product clr6">
            <figcaption>Ladder Barrel</figcaption>
            <img
              src="@/assets/btn-ladderbarrel@1x.png"
              srcset="@/assets/btn-ladderbarrel@2x.png 2x, @/assets/btn-ladderbarrel@3x.png 3x"
              alt="Photo of Ladder Barrel"
            >
          </figure>
        </a>
        <a href="/wunda-chair" title="Learn more about Wunda Chair">
          <figure class="product clr3">
            <figcaption>Wunda Chair</figcaption>
            <img
              src="@/assets/btn-wundachair@1x.png"
              srcset="@/assets/btn-wundachair@2x.png 2x, @/assets/btn-wundachair@3x.png 3x"
              alt="Photo of Wunda Chair"
            >
          </figure>
        </a>
        <a href="/reformer-tower" title="Learn more about the Contrology Reformer with Tower">
          <figure class="product clr2">
            <figcaption>Reformer with Tower</figcaption>
            <img
              src="@/assets/btn-tower@1x.png"
              srcset="@/assets/btn-tower@2x.png 2x, @/assets/btn-tower@3x.png 3x"
              alt="Photo of Reformer with Tower"
            >
          </figure>
        </a>
      </section>
      <section class="icon-grid-wrapper">
        <h1 class="center">Why buy Contrology?</h1>
        <div class="icon-grid">
          <div class="icon">
            <img
              src="@/assets/shipping@1x.png"
              srcset="@/assets/shipping@2x.png 2x"
              alt="Illustration of shipping crate"
            />
            <h3>
              Ready to Ship
              <br />
              <span>in 6 weeks or less!</span>
            </h3>
          </div>
          <div class="icon">
            <img
              src="@/assets/custom-colors@1x.png"
              srcset="@/assets/custom-colors@2x.png 2x"
              alt="Illustration of paintbrush and colors"
            />
            <h3>
              Custom colors
              <br />and accessories
              <!-- <br />
              <span>within 3 weeks!</span> -->
            </h3>
          </div>
          <div class="icon">
            <img
              src="@/assets/customer-service@1x.png"
              srcset="@/assets/customer-service@2x.png 2x"
              alt="Illustration of crown"
            />
            <h3>
              World-class
              <br />customer service
              <br />
              <span>best in industry!</span>
            </h3>
          </div>
          <!-- <div class="icon">
            <img
              src="@/assets/guarantee@1x.png"
              srcset="@/assets/guarantee@2x.png 2x"
              alt="30-Day money-back guarantee"
            />
            <h3>
              30-Day Money
              <br />Back Guarantee
              <br />
              <span>exclusive to Contrology!</span>
            </h3>
          </div> -->
        </div>
      </section>
      <section class="carousel" id="testimonials">
        <div class="carousel-wrapper">
          <Carousel
            :perPage="1"
            :perPageCustom="[[0,1],[650,2],[955,1]]"
            :navigationEnabled="true"
            paginationActiveColor="#ffffff"
            paginationColor="#878787"
            :paginationSize="7"
            :navigationNextLabel="nextIcon"
            :navigationPrevLabel="prevIcon"
          >
            <slide>
              <span @click="showModal12 = true" style="cursor:pointer">
                <img
                  src="@/assets/in-use-christine-waterman@1x.jpg"
                  srcset="@/assets/in-use-christine-waterman@2x.jpg 2x"
                  alt="In use photo"
                  class="in-use"
                  role="button"
                  tabindex="0"
                />
              </span>
              <span @click="showModal12 = true" style="cursor:pointer" role="button" tabindex="0">
                <div class="quote">
                  <img src="@/assets/icon_quote.svg" alt="Open quote icon" />
                  <blockquote>Shout out to Contrology. The time & effort that you put into the Ped-o-Pul was worth it. It works wonderfully.</blockquote>
                  <footer>
                    <img
                      src="@/assets/headshot-christine-waterman@1x.jpg"
                      srcset="@/assets/headshot-christine-waterman@2x.jpg 2x"
                      alt="Headshot photo of Christine Waterman"
                      class="round"
                    />
                    <span>~Christine Waterman</span>
                  </footer>
                </div>
              </span>
            </slide>
            <slide>
              <span @click="showModal11 = true" style="cursor:pointer">
                <img
                  src="@/assets/in-use-amy-rost@1x.jpg"
                  srcset="@/assets/in-use-amy-rost@2x.jpg 2x"
                  alt="In use photo"
                  class="in-use"
                  role="button"
                  tabindex="0"
                />
              </span>
              <span @click="showModal11 = true" style="cursor:pointer" role="button" tabindex="0">
                <div class="quote">
                  <img src="@/assets/icon_quote.svg" alt="Open quote icon" />
                  <blockquote>The Contrology reformer gives my clients the feedback that I have been trying to put words to for all these years.</blockquote>
                  <footer>
                    <img
                      src="@/assets/headshot-amy-rost@1x.jpg"
                      srcset="@/assets/headshot-amy-rost@2x.jpg 2x"
                      alt="Headshot photo of Amy Rost"
                      class="round"
                    />
                    <span>~Amy Rost</span>
                  </footer>
                </div>
              </span>
            </slide>
            <slide>
              <span @click="showModal10 = true" style="cursor:pointer">
                <img
                  src="@/assets/in-use-ann-taboada@1x.jpg"
                  srcset="@/assets/in-use-ann-taboada@2x.jpg 2x"
                  alt="In use photo"
                  class="in-use"
                  role="button"
                  tabindex="0"
                />
              </span>
              <span @click="showModal10 = true" style="cursor:pointer" role="button" tabindex="0">
                <div class="quote">
                  <img src="@/assets/icon_quote.svg" alt="Open quote icon" />
                  <blockquote>The Contrology Arm Chair is ideal for teaching a client how to engage in their powerhouse.</blockquote>
                  <footer>
                    <img
                      src="@/assets/headshot-ann-taboada@1x.jpg"
                      srcset="@/assets/headshot-ann-taboada@2x.jpg 2x"
                      alt="Headshot photo of Ann Taboada"
                      class="round"
                    />
                    <span>~Ann Taboada</span>
                  </footer>
                </div>
              </span>
            </slide>
            <slide>
              <span @click="showModal9 = true" style="cursor:pointer">
                <img
                  src="@/assets/in-use-noor-al-almer@1x.jpg"
                  srcset="@/assets/in-use-noor-al-almer@2x.jpg 2x"
                  alt="In use photo"
                  class="in-use"
                  role="button"
                  tabindex="0"
                />
              </span>
              <span @click="showModal9 = true" style="cursor:pointer" role="button" tabindex="0">
                <div class="quote">
                  <img src="@/assets/icon_quote.svg" alt="Open quote icon" />
                  <blockquote>The firmness of the foam made me feel supported throughout my workout.</blockquote>
                  <footer>
                    <img
                      src="@/assets/headshot-noor-al-amer@1x.jpg"
                      srcset="@/assets/headshot-noor-al-amer@2x.jpg 2x"
                      alt="Headshot photo of Noor Al-Amer"
                      class="round"
                    />
                    <span>~Noor Al-Amer</span>
                  </footer>
                </div>
              </span>
            </slide>
            <slide>
              <span @click="showModal8 = true" style="cursor:pointer">
                <img
                  src="@/assets/in-use-daniela-escobar@1x.jpg"
                  srcset="@/assets/in-use-daniela-escobar@2x.jpg 2x"
                  alt="In use photo"
                  class="in-use"
                  role="button"
                  tabindex="0"
                />
              </span>
              <span @click="showModal8 = true" style="cursor:pointer" role="button" tabindex="0">
                <div class="quote">
                  <img src="@/assets/icon_quote.svg" alt="Open quote icon" />
                  <blockquote>The springs, the lower bars and the firmer padding provide you with great support and give an amazing workout.</blockquote>
                  <footer>
                    <img
                      src="@/assets/headshot-daniela-escobar@1x.jpg"
                      srcset="@/assets/headshot-daniela-escobar@2x.jpg 2x"
                      alt="Headshot photo of Daniela Escobar"
                      class="round"
                    />
                    <span>~Daniela Escobar</span>
                  </footer>
                </div>
              </span>
            </slide>
            <slide>
              <span @click="showModal7 = true" style="cursor:pointer">
                <img
                  src="@/assets/in-use-joel@1x.jpg"
                  srcset="@/assets/in-use-joel@2x.jpg 2x"
                  alt="In use photo"
                  class="in-use"
                  role="button"
                  tabindex="0"
                />
              </span>
              <span @click="showModal7 = true" style="cursor:pointer" role="button" tabindex="0">
                <div class="quote">
                  <img src="@/assets/icon_quote.svg" alt="Open quote icon" />
                  <blockquote>The closest you can get to the reformers in Joe’s studio. The craftsmanship is top quality, and you can get one within a couple weeks.</blockquote>
                  <footer>
                    <img
                      src="@/assets/headshot-joel-crosby@1x.png"
                      srcset="@/assets/headshot-joel-crosby@2x.png 2x"
                      alt="Headshot photo of Joel Crosby"
                      class="round"
                    />
                    <span>~Joel Crosby</span>
                  </footer>
                </div>
              </span>
            </slide>
            <slide>
              <span @click="showModal6 = true" style="cursor:pointer">
                <img
                  src="@/assets/in-use-gina-papalia@1x.jpg"
                  srcset="@/assets/in-use-gina-papalia@2x.jpg 2x"
                  alt="In use photo"
                  class="in-use"
                  role="button"
                  tabindex="0"
                />
              </span>
              <span @click="showModal6 = true" style="cursor:pointer" role="button" tabindex="0">
                <div class="quote">
                  <img src="@/assets/icon_quote.svg" alt="Open quote icon" />
                  <blockquote>Balanced Body ensured that these springs are perfect. They don’t do the work for you, so it’s up to your powerhouse.</blockquote>
                  <footer>
                    <img
                      src="@/assets/headshot-gina-papalia@1x.jpg"
                      srcset="@/assets/headshot-gina-papalia@2x.jpg 2x"
                      alt="Headshot photo of Gina Papalia"
                      class="round"
                    />
                    <span>~Gina Papalia</span>
                  </footer>
                </div>
              </span>
            </slide>
            <slide>
              <span @click="showModal5 = true" style="cursor:pointer">
                <img
                  src="@/assets/in-use-nan-young-kim@1x.jpg"
                  srcset="@/assets/in-use-nan-young-kim@2x.jpg 2x"
                  alt="In use photo"
                  class="in-use"
                  role="button"
                  tabindex="0"
                />
              </span>
              <span @click="showModal5 = true" style="cursor:pointer" role="button" tabindex="0">
                <div class="quote">
                  <img src="@/assets/icon_quote.svg" alt="Open quote icon" />
                  <blockquote>The firm mat on the Contrology Reformer helps me keep my center.</blockquote>
                  <footer>
                    <img
                      src="@/assets/headshot-nan-young-kim@1x.jpg"
                      srcset="@/assets/headshot-nan-young-kim@2x.jpg 2x"
                      alt="Headshot photo of Nan-Young Kim"
                      class="round"
                    />
                    <span>~Nan-Young Kim</span>
                  </footer>
                </div>
              </span>
            </slide>
            <slide>
              <span @click="showModal4 = true" style="cursor:pointer">
                <img
                  src="@/assets/in-use-daniela-mazel@1x.jpg"
                  srcset="@/assets/in-use-daniela-mazel@2x.jpg 2x"
                  alt="In use photo"
                  class="in-use"
                  role="button"
                  tabindex="0"
                />
              </span>
              <span @click="showModal4 = true" style="cursor:pointer" role="button" tabindex="0">
                <div class="quote">
                  <img src="@/assets/icon_quote.svg" alt="Open quote icon" />
                  <blockquote>On the Contrology Reformer, my heels stay connected to the shoulder blocks throughout the entire exercise series.</blockquote>
                  <footer>
                    <img
                      src="@/assets/headshot-daniela-mazal@1x.jpg"
                      srcset="@/assets/headshot-daniela-mazal@2x.jpg 2x"
                      alt="Headshot photo of Daniela Mazal"
                      class="round"
                    />
                    <span>~Daniela Mazal</span>
                  </footer>
                </div>
              </span>
            </slide>
            <slide>
              <span @click="showModal2 = true" style="cursor:pointer">
                <img
                  src="@/assets/in-use-andy-adamson@1x.jpg"
                  srcset="@/assets/in-use-andy-adamson@2x.jpg 2x"
                  alt="In use photo"
                  class="in-use"
                  role="button"
                  tabindex="0"
                />
              </span>
              <span @click="showModal2 = true" style="cursor:pointer" role="button" tabindex="0">
                <div class="quote">
                  <img src="@/assets/icon_quote.svg" alt="Open quote icon" />
                  <blockquote>The Contrology Reformer makes you do Pilates in the way that Joe really intended you do Pilates.</blockquote>
                  <footer>
                    <img
                      src="@/assets/headshot-andy-adamson@1x.png"
                      srcset="@/assets/headshot-andy-adamson@2x.png 2x"
                      alt="Headshot photo of Andy Adamson"
                    />
                    <span>~Andy Adamson</span>
                  </footer>
                </div>
              </span>
            </slide>
            <slide>
              <span>
                <img
                  src="@/assets/photo_in-use@1x.jpg"
                  srcset="@/assets/photo_in-use@2x.jpg 2x"
                  alt="In use photo"
                  class="in-use"
                />
              </span>
              <span>
                <div class="quote">
                  <img src="@/assets/icon_quote.svg" alt="Open quote icon" />
                  <blockquote>The Contrology Reformer has allowed me to work the method as I had learned in the 80's.</blockquote>
                  <footer>
                    <img
                      src="@/assets/photo_headshot@1x.png"
                      srcset="@/assets/photo_headshot@2x.png 2x"
                      alt="Headshot photo of Kathi Ross-Nash"
                    />
                    <span>~Kathi Ross-Nash</span>
                  </footer>
                </div>
              </span>
            </slide>
            <slide>
              <span>
                <img
                  src="@/assets/in-use-kati@1x.jpg"
                  srcset="@/assets/in-use-kati@2x.jpg 2x"
                  alt="In use photo"
                  class="in-use"
                />
              </span>
              <span>
                <div class="quote">
                  <img src="@/assets/icon_quote.svg" alt="Open quote icon" />
                  <blockquote>Small details come into practice more in depth. It really sets the body into right places without having to think about it.</blockquote>
                  <footer>
                    <img
                      src="@/assets/headshot-kati-pylkkanen@1x.png"
                      srcset="@/assets/headshot-kati-pylkkanen@2x.png 2x"
                      alt="Headshot photo of Kati-Pylkkänen"
                    />
                    <span>~Kati-Pylkkänen</span>
                  </footer>
                </div>
              </span>
            </slide>
          </Carousel>
        </div>
      </section>
      <section class="card-grid-wrapper">
        <h1 class="center">The latest in Contrology</h1>
        <div class="card-grid">
          <div class="card">
            <img
              src="@/assets/contrology-training@1x.png"
              srcset="@/assets/contrology-training@2x.png 2x"
              alt="Photo of instructor and a group of students"
            />
            <div class="card-content">
              <h3>Teacher Training</h3>
              <p>Classical Pilates training programs are flourishing worldwide. Is yours featured here? If not, let us know!</p>
              <a href="trainings" title="Learn more">Find or List Teacher Training</a>
            </div>
          </div>
          <div class="card">
            <img
              src="@/assets/contrology-atc@1x.png"
              srcset="@/assets/contrology-atc@2x.png 2x"
              alt="Photo of person working out on a Contrology Reformer"
            />
            <div class="card-content">
              <h3>Test Drive Contrology</h3>
              <p>Authorized Demo Centers worldwide give the opportunity to "see and feel" Contrology apparatus in person.</p>
              <a href="demo-centers" title="Learn more">Find an Authorized Demo Center</a>
            </div>
          </div>
          <div class="card">
            <img
              src="@/assets/contrology-classical@1x.png"
              srcset="@/assets/contrology-classical@2x.png 2x"
              alt="Group workout photo"
            />
            <div class="card-content">
              <h3>Classical Events</h3>
              <p>The growing list of Classical Pilates events worldwide is a testament to the community.</p>
              <a href="events" title="Learn more">Find or List a Classical Event</a>
            </div>
          </div>
        </div>
      </section>
      <section class="insta">
        <a href="https://instagram.com/contrology.bb" title="Visit us on Instagram" target="_blank">
          <img src="@/assets/icon-insta-thin.svg" alt="Instagram logo" class="social" />
          <span>Contrology on Instagram<br><em>@contrology.bb</em></span>
        </a>
      </section>
    </main>
    <Modal v-if="showModal" @close="showModal = false">
      <div slot="header"></div>
      <div slot="body">
        <div class="embed-container">
          <iframe title="This is an embedded iframe video" src="https://www.youtube.com/embed/b8OCCuOTLnA?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
    <Modal v-if="showModal2" @close="showModal2 = false">
      <div slot="header"></div>
      <div slot="body">
        <div class="embed-container">
          <iframe title="This is an embedded iframe video" src="https://www.youtube.com/embed/bKgM3dFGRA4?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
    <!-- <Modal v-if="showModal3" @close="showModal3 = false">
      <div slot="header"></div>
      <div slot="body">
        <div class="embed-container">
          <iframe title="This is an embedded iframe video" src="https://www.youtube.com/embed/EL70AA8FisY?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal> -->
    <Modal v-if="showModal4" @close="showModal4 = false">
      <div slot="header"></div>
      <div slot="body">
        <div class="embed-container">
          <iframe title="This is an embedded iframe video" src="https://www.youtube.com/embed/3w19gl9mB5U?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
    <Modal v-if="showModal5" @close="showModal5 = false">
      <div slot="header"></div>
      <div slot="body">
        <div class="embed-container">
          <iframe title="This is an embedded iframe video" src="https://www.youtube.com/embed/pBZw_gTxZu8?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
    <Modal v-if="showModal6" @close="showModal6 = false">
      <div slot="header"></div>
      <div slot="body">
        <div class="embed-container">
          <iframe title="This is an embedded iframe video" src="https://www.youtube.com/embed/ofb-IKqY_cA?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
    <Modal v-if="showModal7" @close="showModal7 = false">
      <div slot="header"></div>
      <div slot="body">
        <div class="embed-container">
          <iframe title="This is an embedded iframe video" src="https://www.youtube.com/embed/Gff4OvInZPY?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
    <Modal v-if="showModal8" @close="showModal8 = false">
      <div slot="header"></div>
      <div slot="body">
        <div class="embed-container">
          <iframe title="This is an embedded iframe video" src="https://www.youtube.com/embed/teHkzB5tGz0?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
    <Modal v-if="showModal9" @close="showModal9 = false">
      <div slot="header"></div>
      <div slot="body">
        <div class="embed-container">
          <iframe title="This is an embedded iframe video" src="https://www.youtube.com/embed/KbZgkEav6sM?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
    <Modal v-if="showModal10" @close="showModal10 = false">
      <div slot="header"></div>
      <div slot="body">
        <div class="embed-container">
          <iframe title="This is an embedded iframe video" src="https://www.youtube.com/embed/ckk2KgoX0dU?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
    <Modal v-if="showModal11" @close="showModal11 = false">
      <div slot="header"></div>
      <div slot="body">
        <div class="embed-container">
          <iframe title="This is an embedded iframe video" src="https://www.youtube.com/embed/wXbsoJhJaSc?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
    <Modal v-if="showModal12" @close="showModal12 = false">
      <div slot="header"></div>
      <div slot="body">
        <div class="embed-container">
          <iframe title="This is an embedded iframe video" src="https://www.youtube.com/embed/DllM5b5CyrM?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import Modal from '@/components/Modal.vue';
// import Banner from '@/components/Banner.vue';

export default {
  metaInfo: {
    title: "Classical Pilates - Contrology Pilates Reformers & Equipment",
    titleTemplate: "%s",
    meta: [
      {
        name: "description",
        content: "Discover how Contrology offers Classical Pilates enthusiasists an authentic line of pilates reformers & apparatus. See what our pilates equipment can do for you."
      }
    ]
  },

  components: {
    Carousel,
    Slide,
    Modal,
    // Banner
  },

  data() {
    return {
      showModal: false,
      showModal2: false,
      showModal4: false,
      showModal5: false,
      showModal6: false,
      showModal7: false,
      showModal8: false,
      showModal9: false,
      showModal10: false,
      showModal11: false,
      showModal12: false,
    }
  },

  computed: {
    nextIcon() {
      return `<svg width="13" height="27" viewBox="0 0 13 27" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.51922 0.624325C1.21151 -0.208109 2.33394 -0.208109 3.02623 0.624325L12.4808 11.9927C13.1731 12.8252 13.1731 14.1748 12.4808 15.0073L3.02624 26.3757C2.33395 27.2081 1.21152 27.2081 0.519224 26.3757C-0.173069 25.5432 -0.173069 24.1936 0.519224 23.3612L8.72026 13.5L0.51922 3.63883C-0.173073 2.8064 -0.173073 1.45676 0.51922 0.624325Z"/>
</svg>`;
    },

    prevIcon() {
      return `<svg width="13" height="27" viewBox="0 0 13 27" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.4808 26.3757C11.7885 27.2081 10.6661 27.2081 9.97377 26.3757L0.519221 15.0073C-0.173073 14.1748 -0.173073 12.8252 0.519222 11.9927L9.97377 0.624325C10.6661 -0.208107 11.7885 -0.208107 12.4808 0.624325C13.1731 1.45676 13.1731 2.8064 12.4808 3.63884L4.27974 13.5L12.4808 23.3612C13.1731 24.1936 13.1731 25.5432 12.4808 26.3757Z"/>
</svg>`;
    }
  }
};
</script>

<style scoped>
.narrow {
  display: block;
}

.wide {
  display: none;
}

h1 {
  margin: 0 auto;
  margin: 20px 0;
}

.product-grid {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  margin-top: 10px;
  max-width: 1000px;
  margin: 10px auto 0;
}

.product-grid a {
  cursor: pointer;
  text-decoration: none;
}

.product {
  margin: 0 auto;
  padding: 0;
  flex: 1;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 1fr 4fr;
  max-width: 316px;
}

.product img {
  grid-row: 1 / span 2;
  grid-column: 1 / span 1;
  width: 100%;
}

.product figcaption {
  grid-row: 1 / span 1;
  grid-column: 1 / span 1;
  z-index: 100;
  justify-self: center;
  align-self: flex-end;
  font-family: var(--noto);
  font-size: 1.25rem;
  color: var(--black);
}

.product.clr1 {
  background-color: #dce5ba;
}

.product.clr1:hover {
  background-color: #f3f8e2;
}

.product.clr2 {
  background-color: #abb290;
}

.product.clr2:hover {
  background-color: #dde6bd;
}

.product.clr3 {
  background-color: #e3d5ae;
}

.product.clr3:hover {
  background-color: #f7eed6;
}

.product.clr4 {
  background-color: #c5b486;
}

.product.clr4:hover {
  background-color: #ecdfbb;
}

.product.clr5 {
  /* background: rgba(255, 255, 255, 0.5); */
  background-color: #c5d1a2;
}

.product.clr5:hover {
  background-color: #d5e2ae;
}

.temp-quote {
  font-family: var(--noto);
  font-style: italic;
  font-weight: 300;
  font-size: 20px;
  line-height: 27px;
  text-align: center;
  color: #000000;
}

.product.clr6 {
  background-color: #e8e6a9;
}

.product.clr6:hover {
  background-color: #f8f6bb;
}

.product img {
  mix-blend-mode: multiply;
}

.icon-grid-wrapper {
  margin: 40px auto 0;
  max-width: 996px;
}

.icon-grid, .icon {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
}

.icon {
  margin-bottom: 40px;
}

.icon-grid h3 {
  font-family: var(--noto);
  font-weight: 300;
  font-size: 1.25rem;
  line-height: 110%;
  color: var(--black);
  margin-top: 25px;
  text-align: center;
}

.icon-grid span {
  padding-top: 14px;
  display: block;
  font-style: italic;
}

.VueCarousel-slide {
  height: 100%;
  padding: 15px;
  background-color: #fff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
}

.VueCarousel-slide a {
  text-decoration: none;
}

.VueCarousel-slide img.in-use {
  width: 100%;
  margin-bottom: 10px;
  display: block;
  margin: 0 auto;
}

.quote {
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  justify-content: space-around;
  height: 300px;
}

.VueCarousel-slide blockquote,
.VueCarousel-slide footer span {
  margin: 0;
  padding: 0;
  font-family: var(--noto);
  font-weight: 300;
  font-style: italic;
  font-size: 1.125rem;
  line-height: 130%;
  color: var(--black);
}

.VueCarousel-slide footer span {
  font-size: 1rem;
  line-height: 135%;
  padding-left: 10px;
}

.VueCarousel-slide footer {
  display: flex;
  align-items: center;
}

::v-deep .VueCarousel-dot-container {
  display: block !important;
  margin: -10px !important;
  padding: 0;
  text-align: right;
}

::v-deep .VueCarousel-navigation-button:focus {
  outline: none;
}

::v-deep .VueCarousel-navigation-prev {
  left: 4px;
}

::v-deep .VueCarousel-navigation-next {
  right: 4px;
}

.round {
  border-radius: 36px;
}

.card-grid-wrapper {
  max-width: 996px;
  margin: 60px auto 40px;
}

.card-grid {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
}

.card {
  background-color: var(--white);
  border-radius: 5px;
  width: 100%;
  max-width: 288px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
  margin-bottom: 40px;
  padding-bottom: 40px;
}

.card img {
  display: block;
  width: 100%;
  max-width: 288px;
}

.card a {
  text-decoration: none;
}

.card-content {
  border-top: 6px solid var(--black);
  padding: 23px 37px 0 25px;
}

.card-content h3 {
  font-family: var(--noto);
  font-weight: 400;
  font-size: 1.125rem;
  line-height: 1.5;
  text-align: left;
  color: #333333;
  border-bottom: 2px solid var(--black);
  margin: 0;
  padding-bottom: 10px;
}

.card-content p,
.card-content a {
  font-family: var(--roboto);
  color: #333333;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.4;
}

.card-content a {
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
}

.insta {
  border-top: 2px solid var(--black);
}

.insta img {
  width: 30px;
  height: 30px;
  margin: 0 auto;
}

.insta a {
  display: flex;
  flex-flow: column nowrap;;
  text-decoration: none;
  font-family: var(--noto);
  font-size: 1.25rem;
  font-weight: 300;
  line-height: 1.4;
  color: var(--black);
  white-space: nowrap;
  text-align: center;
  margin: 30px 0;
}

.insta a em {
  font-size: 1.125rem;
  font-style: italic;
}

.youtube-wrapper {
  width: 100%;
  max-width: 996px;
  margin: 0 auto;
  position: relative;
}

.video {
  width: 100%;
}

.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}

.embed-container iframe,
.embed-container object,
.embed-container embed { 
  position: absolute; 
  top: 0; 
  left: 0; 
  width: 100%; 
  height: 100%; 
}

.btn-wrapper {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-37px, -37px);
}

.btn-wrapper>span {
    width: 70px;
    height: 70px;
    border: 2px solid var(--white);
    background-color: var(--black);
    display: flex;
    justify-content: center;
    align-items: center;
    vertical-align: middle;
    border-radius: 36px;
}

.btn-wrapper span span {
    width: 0;
    height: 0;
    font-size: 0;
    line-height: 0;
    border-top: 16px solid transparent;
    border-left: 24px solid var(--white);
    border-bottom: 16px solid transparent;
    margin-left: 7px;
}

a .btn-wrapper>span,
a:hover .btn-wrapper>span span {
    transition: all .2s ease-in-out;
}

a:hover .btn-wrapper>span,
a:hover .btn-wrapper>span span {
    transform: scale(1.1);
}

.center {
  text-align: center;
}

@media only screen and (min-width:600px) {
  .narrow {
    display: none;
  }

  .wide {
    width: 100%;
    max-width: 996px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }

  .product-grid {
    margin-top: 40px;
  }

  .icon-grid-wrapper {
    margin-top: 60px;
  }
}

@media only screen and (min-width:768px) {
  .icon-grid {
    flex-flow: row wrap;
  }

  .icon {
    flex-basis: 25%;
  }

  .card-grid {
    flex-flow: row wrap;
    justify-content: space-evenly;
  }

  .card {
    display: flex;
    flex-flow: column nowrap;
    height: 380px;
    margin-right: 5px;
    margin-left: 5px;
  }
}

@media only screen and (min-width:955px) {
  h1 {
    margin-bottom: 40px;
    margin-top: 50px;
    text-align: center;
  }

  /* .product-grid {
    flex-flow: row nowrap;
  }  */
 
  /* .product img {
    max-width: 248px;
  } */

  .insta a {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    padding: 0;
  }

  .insta img {
    width: 53px;
    height: 53px;
    margin: 0;
  }

  .insta span {
    text-align: left;
    padding-left: 15px;
  }

  .carousel {
    height: 500px;
    width: calc(100% + 54px);
    margin-left: -27px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgb(0, 0, 0, 0.75);
  }

  .carousel-wrapper {
    width: 783px;
  }

  .VueCarousel-slide {
    padding: 25px;
    display: flex;
    align-items: center;
    box-shadow: none;
    margin: 0;
    height: auto;
    max-width: none;
  }

  .VueCarousel-slide img.in-use {
    width: 300px;
    margin-bottom: 0;
    margin-right: 25px;
  }

  .VueCarousel-slide blockquote,
  .VueCarousel-slide footer span {
    font-size: 1.3rem;
  }

  .VueCarousel-slide footer span {
    font-size: 1.125rem;
    line-height: 135%;
  }

  ::v-deep .VueCarousel-navigation-prev {
    left: 0;
  }

  ::v-deep .VueCarousel-navigation-next {
    right: 0;
  }

  ::v-deep .VueCarousel-navigation-button svg {
    fill: #878787;
  }
}
</style>
